import * as yup from 'yup';

export const creditDetailsFormSchema = yup.object({
  showDivision: yup.boolean().default(false),
  division: yup
    .string()
    .when('showDivision', {
      is: true,
      then: (schema) =>
        schema.required('Division is required'),
      otherwise: (schema) => schema.notRequired(),
    })
    .nullable(),
  enterprise: yup
    .string()
    .default('')
    .required('Credit Partner is required')
    .nullable(),
  option: yup.string().default('0').required(),
});

export type TCreditDetailsFormData = yup.InferType<
  typeof creditDetailsFormSchema
>;
